import './SidebarAnimator.scss';

const CONTENT_CONTAINER_SELECTOR = '.sidebar-navigation-content';
const SIDEBAR_OPEN = 'sidebar-open';
const OUTSIDE_SIDEBAR_SELECTOR = '.outside-sidebar';

/**
 * Controls animation of main content so that the sidebar becomes visible.
 */
export default class SidebarAnimator {
  /**
   * Create a new `SidebarAnimator`, associating it with the provided close function.
   * @param {Function} onClose Function to be called if the user wishes to close the sidebar.
   */
  constructor(onClose) {
    this.closeCallback = onClose;
  }

  /**
   * @private
   * Handles closing of the sidebar when requested
   */
  handleClose = isOpen => {
    this.closeCallback(isOpen);
  };

  /**
   * Opens the sidebar using CSS-based transforms
   */
  open() {
    const contentContainer = document.querySelector(CONTENT_CONTAINER_SELECTOR);
    const outsideArea = document.querySelector(OUTSIDE_SIDEBAR_SELECTOR);

    contentContainer.classList.add(SIDEBAR_OPEN);
    setTimeout(() => {
      outsideArea.addEventListener('click', () => this.handleClose(true));
    }, 0);
  }

  /**
   * Closes the sidebar using CSS-based transforms
   */
  close() {
    const contentContainer = document.querySelector(CONTENT_CONTAINER_SELECTOR);
    const outsideArea = document.querySelector(OUTSIDE_SIDEBAR_SELECTOR);

    contentContainer.classList.remove(SIDEBAR_OPEN);
    outsideArea.removeEventListener('click', () => this.handleClose(false));
  }
}
